import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(3),
    height: '100%'
  },
  filters: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    borderRight: `1px solid ${theme.palette.divider}`,
    height: '100%'
  },
  formControl: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    minWidth: 150,
    maxWidth: '100%'
  },
  chartContainer: {
    height: 500,
    position: 'relative',
    marginBottom: theme.spacing(3)
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 400
  },
  error: {
    padding: theme.spacing(2),
    color: theme.palette.error.main,
    border: `1px solid ${theme.palette.error.main}`,
    borderRadius: theme.shape.borderRadius,
    margin: theme.spacing(2, 0)
  },
  noData: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 400,
    border: `1px dashed ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius
  },
  disclaimer: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
    fontStyle: 'italic',
    color: theme.palette.text.secondary
  },
  dataSourceToggle: {
    marginTop: theme.spacing(2)
  },
  sourceButton: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1)
  }
}));
